
const env = process.env.REACT_APP_ENVIRONMENT || 'development';
const Config = require (`../../environment/${env}.json`);
export default Config;